import React, { useEffect, useState } from "react";
import {
	Nav,
	Navbar,
	Collapse,
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	Dropdown,
	UncontrolledDropdown,
	NavbarToggler
} from "reactstrap";

import {
	User,
	Bell,
	LogOut,
	Globe,
	ChevronDown,
	ChevronUp,
	Package,
	Loader,
	Menu,
	X,
	MoreVertical
} from "react-feather";

import LiveSearch from "./liveSearch";
import { connect } from "react-redux";
import userService from "../../../services/userService";
import notificationService from "../../../services/notificationService";
import { IApplicationState } from "../../../redux/reducers";
import NotificationDropdown from "./NotificationDropdown/NotificationDropdown";
import { INotification } from "../../../interfaces/notification";
import BrandDropdown from "./BrandDropdown";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { routes } from "../../../routes/routes";
import { IBrand } from "../../../interfaces/company";
import ReactImageFallback from "react-image-fallback";
import ViewModeToggle from "./ViewModeToggle";
import { setViewModeAction } from "../../../redux/actions/user/userActions";
import { ViewMode } from "../../../redux/actions/user/userAction";
import { Dispatch } from "redux";
import LogoutConfirmationModal from "../../modals/LogoutConfirmationModal";
// Import debug utilities for topbar debugging - REMOVED FOR PRODUCTION

interface IProps {
	logout: () => void;
	profile: any;
	fetchProfile: () => Promise<any>;
	notifications: INotification[];
	getAllNotifications: () => Promise<any>;
	markAsRead: (id: string) => Promise<any>;
	setSelectedBrand: (brand: IBrand) => Promise<any>;
	selected_brand: IBrand;
	currentViewMode: ViewMode;
	setViewMode: (mode: ViewMode) => void;
}

// Props with router props included
type PropsWithRouter = IProps & RouteComponentProps;

const Header: React.FC<PropsWithRouter> = (props) => {
	const [notificationDropdown, setNotificationDropdown] = useState<boolean>(false);
	const [brandDropdown, setBrandDropdown] = useState<boolean>(false);
	const [brand, setBrand] = useState<IBrand>(props.selected_brand);
	const [loadingNotifications, setLoadingNotifications] = useState<boolean>(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
	const [isThreeDotsMenuOpen, setIsThreeDotsMenuOpen] = useState<boolean>(false);
	const [threeDotsMenuPosition, setThreeDotsMenuPosition] = useState<{ top: number; left: number }>({ top: 64, left: 12 });
	const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);

	// Separate state for mobile menu dropdowns
	const [mobileBrandDropdown, setMobileBrandDropdown] = useState<boolean>(false);
	const [mobileNotificationDropdown, setMobileNotificationDropdown] = useState<boolean>(false);
	const [threeDotsBrandDropdown, setThreeDotsBrandDropdown] = useState<boolean>(false);
	const [threeDotsNotificationDropdown, setThreeDotsNotificationDropdown] = useState<boolean>(
		false
	);
	const [threeDotsProfileDropdown, setThreeDotsProfileDropdown] = useState<boolean>(false);

	const notificationCount = props.notifications.filter(
		(n: INotification) => !n.is_read && n.message !== "New Ingredient Added"
	).length;

	const toggleNotificationDropdown = (e?: React.MouseEvent) => {
		// Check if this is a user-initiated open (clicking the bell icon)
		// If so, clear the "just closed" flag to allow opening
		let isBellIconClick = false;
		if (e) {
			const target = e.target as Element;
			// Check multiple selectors to catch bell icon clicks
			const bellIcon = target.closest('.notification-bell-icon') ||
				target.closest('[data-notification-toggle]') ||
				target.closest('.navbar-nav .dropdown-toggle') ||
				target.closest('.notification-container') ||
				target.closest('.d-flex.align-items-center.justify-content-center.position-relative');

			// Also check if the click is on the DropdownToggle itself
			const isDropdownToggle = target.closest('.dropdown-toggle.nav');

			if (bellIcon || isDropdownToggle) {
				isBellIconClick = true;
				// Clear the "just closed" flag to allow opening
				(document as any).__notificationJustClosed = null;
				(document as any).__notificationSuppressToggle = false;
			}
		}

		// If no event but state is false, assume it's a legitimate open attempt
		// (reactstrap might call toggle without event in some cases)
		if (!e && !notificationDropdown) {
			(document as any).__notificationJustClosed = null;
			(document as any).__notificationSuppressToggle = false;
			isBellIconClick = true;
		}

		// Check if toggle is suppressed (set when closing with X button)
		// This prevents reactstrap's double-toggle issue after closing
		const suppressToggle = (document as any).__notificationSuppressToggle;
		if (suppressToggle && !isBellIconClick) {
			return; // Don't toggle if suppressed and not a bell icon click
		}

		// Check if dropdown was just closed - prevent ALL toggles for a short period
		// This prevents reactstrap's double-toggle issue after closing with X button
		const justClosedTime = (document as any).__notificationJustClosed;
		if (justClosedTime && !isBellIconClick) {
			const timeSinceClose = Date.now() - justClosedTime;

			// If it was just closed (within 500ms), prevent ALL toggles
			// This blocks reactstrap's immediate toggle call after closing
			if (timeSinceClose < 500) {
				return; // Don't toggle at all if it was just closed
			}

			// If more than 500ms has passed, allow toggling but clear the flag
			// This allows legitimate opens after the cooldown period
			if (timeSinceClose >= 500) {
				(document as any).__notificationJustClosed = null;
			}
		}

		// Check document-level flag FIRST - this should be set on mousedown
		const documentFlag = (document as any).__notificationCloseClicked;

		// Check flag - this is set in capture phase before reactstrap calls toggle
		const closeButtonClicked = document.querySelector('[data-close-notification-clicked]');

		// Check if the active element or last clicked element is the close button
		// This works even if reactstrap doesn't pass the event
		const activeElement = document.activeElement;
		const isCloseButtonActive = activeElement?.closest?.('[data-close-notification="true"]') ||
			activeElement?.closest?.('.notification-close-button');

		// Also check the last event target from a global tracker
		const lastClickTarget = (window as any).__lastNotificationClickTarget;
		const isLastClickCloseButton = lastClickTarget?.closest?.('[data-close-notification="true"]') ||
			lastClickTarget?.closest?.('.notification-close-button');

		// If any check indicates close button, don't toggle
		if (documentFlag || closeButtonClicked || isCloseButtonActive || isLastClickCloseButton) {
			// Clear flags IMMEDIATELY after checking
			(document as any).__notificationCloseClicked = false;
			(window as any).__lastNotificationClickTarget = null;
			if (closeButtonClicked) {
				closeButtonClicked.removeAttribute('data-close-notification-clicked');
			}
			return; // Don't toggle, just close
		}

		// Also check if the click target is the close button (backup check)
		if (e) {
			const target = e.target as Element;
			const isCloseButton = target.closest('[data-close-notification="true"]') ||
				target.closest('.notification-close-button');
			if (isCloseButton) {
				// Clear flags
				(document as any).__notificationCloseClicked = false;
				(window as any).__lastNotificationClickTarget = null;
				return; // Don't toggle, just close
			}
		}

		// Clear any stale flags before toggling (safety measure)
		// Clear flags that are older than 500ms to prevent interference
		const flagAge = (document as any).__notificationCloseFlagTime;
		const now = Date.now();
		if (!flagAge || (now - flagAge) > 500) {
			(document as any).__notificationCloseClicked = false;
			(window as any).__lastNotificationClickTarget = null;
		}

		// Also clear "just closed" flag if we're trying to open (state is false)
		// This allows opening even if it was just closed
		if (!notificationDropdown) {
			(document as any).__notificationJustClosed = null;
		}

		setNotificationDropdown(!notificationDropdown);
	};
	const toggleBrandDropdown = () => setBrandDropdown(!brandDropdown);
	const handleBrandChange = (brand: IBrand) => {
		setBrand(brand);
		// Close three-dots menu when brand is selected on mobile
		setThreeDotsBrandDropdown(false);
		setIsThreeDotsMenuOpen(false);
	};

	// Mobile menu dropdown toggles
	const toggleMobileBrandDropdown = () => setMobileBrandDropdown(!mobileBrandDropdown);
	const toggleMobileNotificationDropdown = () =>
		setMobileNotificationDropdown(!mobileNotificationDropdown);

	// Three dots menu dropdown toggles
	const toggleThreeDotsBrandDropdown = () => {
		setThreeDotsBrandDropdown(!threeDotsBrandDropdown);
		// Close other dropdowns when opening one
		if (!threeDotsBrandDropdown) {
			setThreeDotsNotificationDropdown(false);
			setThreeDotsProfileDropdown(false);
		}
	};
	const toggleThreeDotsNotificationDropdown = () => {
		setThreeDotsNotificationDropdown(!threeDotsNotificationDropdown);
		// Close other dropdowns when opening one
		if (!threeDotsNotificationDropdown) {
			setThreeDotsBrandDropdown(false);
			setThreeDotsProfileDropdown(false);
		}
	};
	const toggleThreeDotsProfileDropdown = () => {
		setThreeDotsProfileDropdown(!threeDotsProfileDropdown);
		// Close other dropdowns when opening one
		if (!threeDotsProfileDropdown) {
			setThreeDotsBrandDropdown(false);
			setThreeDotsNotificationDropdown(false);
		}
	};
	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
		setIsThreeDotsMenuOpen(false); // Close three-dots menu when opening mobile menu
	};

	const toggleThreeDotsMenu = () => {
		if (!isThreeDotsMenuOpen) {
			// Calculate position when opening
			const button = document.querySelector('.three-dots-menu-toggle, .ipad-three-dots-menu-toggle') as HTMLElement;
			if (button) {
				const rect = button.getBoundingClientRect();
				const viewportWidth = window.innerWidth;
				const dropdownWidth = 280;
				
				// Position dropdown below the button and align to the right edge
				let top = rect.bottom + 8;
				let left = rect.right - dropdownWidth;
				
				// Ensure dropdown doesn't go off-screen horizontally (left side)
				if (left < 12) {
					left = 12;
				}
				
				// Ensure dropdown doesn't go off-screen horizontally (right side)
				if (left + dropdownWidth > viewportWidth - 12) {
					left = viewportWidth - dropdownWidth - 12;
				}
				
				setThreeDotsMenuPosition({ top, left });
			}
		} else {
			// Close all nested dropdowns when closing the main menu
			setThreeDotsBrandDropdown(false);
			setThreeDotsNotificationDropdown(false);
			setThreeDotsProfileDropdown(false);
		}
		setIsThreeDotsMenuOpen(!isThreeDotsMenuOpen);
		setIsMobileMenuOpen(false); // Close mobile menu when opening three-dots menu
	};

	const handleViewModeChange = (mode: ViewMode) => {
		if (mode !== props.currentViewMode) {
			// Always allow toggle - no validation blocking
			// Data will be faded/blurred on dashboard if not subscribed
			props.setViewMode(mode);
			// Redirect to dashboard when view mode changes
			props.history.push(routes.DASHBOARD);
		}
	};

	useEffect(() => {
		props.fetchProfile();
		setLoadingNotifications(true);
		props.getAllNotifications().finally(() => setLoadingNotifications(false));
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		props.setSelectedBrand(brand);
		// eslint-disable-next-line
	}, [brand]);

	// Close mobile menu when clicking outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const target = event.target as Element;

			// Close mobile menu if clicking outside
			if (isMobileMenuOpen && !target.closest(".topbar")) {
				setIsMobileMenuOpen(false);
			}

			// Close three-dots menu if clicking outside
			if (isThreeDotsMenuOpen) {
				const isInsideThreeDots = target.closest(".three-dots-menu-wrapper") ||
					target.closest(".three-dots-menu-container") ||
					target.closest(".ipad-three-dots-menu-wrapper") ||
					target.closest(".ipad-three-dots-menu-container") ||
					target.closest(".account-dropdown");

				if (!isInsideThreeDots) {
					setIsThreeDotsMenuOpen(false);
					// Close all nested dropdowns when closing the main menu
					setThreeDotsBrandDropdown(false);
					setThreeDotsNotificationDropdown(false);
					setThreeDotsProfileDropdown(false);
				}
			}

			// Close profile dropdown if clicking outside of it (but inside three-dots menu)
			if (threeDotsProfileDropdown && isThreeDotsMenuOpen) {
				const isInsideProfileDropdown = target.closest(".account-dropdown");
				const isProfileToggle = target.closest(".profile-container");

				if (!isInsideProfileDropdown && !isProfileToggle) {
					setThreeDotsProfileDropdown(false);
				}
			}

			// Close desktop notification dropdown if clicking outside
			if (notificationDropdown) {
				const isInsideNotification = target.closest(".header-notification-container") ||
					target.closest(".notification-container") ||
					target.closest(".notification-dropdown-wrapper");

				if (!isInsideNotification) {
					setNotificationDropdown(false);
				}
			}

			// Close mobile notification dropdown if clicking outside
			if (mobileNotificationDropdown) {
				const isInsideNotification = target.closest(".header-notification-container") ||
					target.closest(".notification-container") ||
					target.closest(".notification-dropdown-wrapper");

				if (!isInsideNotification) {
					setMobileNotificationDropdown(false);
				}
			}

			// Close three-dots notification dropdown if clicking outside
			if (threeDotsNotificationDropdown && isThreeDotsMenuOpen) {
				const isInsideNotification = target.closest(".header-notification-container") ||
					target.closest(".notification-container") ||
					target.closest(".notification-dropdown-wrapper");

				if (!isInsideNotification) {
					setThreeDotsNotificationDropdown(false);
				}
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMobileMenuOpen, isThreeDotsMenuOpen, threeDotsProfileDropdown, notificationDropdown, mobileNotificationDropdown, threeDotsNotificationDropdown]);

	// Prevent body scroll when three-dots menu is open
	useEffect(() => {
		if (isThreeDotsMenuOpen) {
			// Save current scroll position
			const scrollY = window.scrollY;
			// Disable body scroll while preserving scroll position
			document.body.style.position = 'fixed';
			document.body.style.top = `-${scrollY}px`;
			document.body.style.width = '100%';
			document.body.style.overflow = 'hidden';

			// Store scroll position for restoration
			(document.body as any).__scrollPosition = scrollY;
		} else {
			// Restore scroll position
			const scrollY = (document.body as any).__scrollPosition || 0;
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.width = '';
			document.body.style.overflow = '';
			// Restore scroll position
			window.scrollTo(0, scrollY);
			delete (document.body as any).__scrollPosition;
		}

		// Cleanup on unmount
		return () => {
			const scrollY = (document.body as any).__scrollPosition || 0;
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.width = '';
			document.body.style.overflow = '';
			window.scrollTo(0, scrollY);
			delete (document.body as any).__scrollPosition;
		};
	}, [isThreeDotsMenuOpen]);

	// Close mobile menu on route change
	useEffect(() => {
		setIsMobileMenuOpen(false);
		setIsThreeDotsMenuOpen(false);
		// Close all nested dropdowns
		setThreeDotsBrandDropdown(false);
		setThreeDotsNotificationDropdown(false);
		setThreeDotsProfileDropdown(false);
		// Close notification dropdowns
		setNotificationDropdown(false);
		setMobileNotificationDropdown(false);
	}, [props.location.pathname]);

	return (
		<>
			<header className="topbar navbarbg" data-navbarbg="skin1">
				<Navbar className="top-navbar d-flex align-items-center justify-content-between" dark expand="lg">
					{/* Search Section - Left/Center */}
					<div className="search-section d-flex align-items-center flex-grow-1">
						<LiveSearch />
					</div>

					{/* Mobile/Tablet Right Section - Contains three dots */}
					<div className="d-md-none mobile-right-section d-flex align-items-center position-relative">
						{/* Three Dots Menu - Only on small screens (below 768px) */}
						<div className="three-dots-menu-wrapper position-relative">
							<button
								onClick={(e) => {
									toggleThreeDotsMenu();
								}}
								className="three-dots-menu-toggle"
								style={{
									border: "none",
									background: "transparent",
									padding: "8px",
									color: "#000",
									cursor: "pointer",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginLeft: "4px",
									position: "relative",
									zIndex: 1001,
									width: "40px",
									height: "40px",
									borderRadius: "4px",
									transition: "background-color 0.2s ease"
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = "transparent";
								}}
							>
								<MoreVertical size={24} />
							</button>

							{/* Three Dots Menu Dropdown - Only on small screens (below 768px) */}
							{isThreeDotsMenuOpen && (
								<div
									className="three-dots-menu-container"
									style={{
										top: `${threeDotsMenuPosition.top}px`,
										left: `${threeDotsMenuPosition.left}px`
									}}
									onClick={(e) => e.stopPropagation()}
								>
									{/* Unified Menu - All items in one dropdown */}
									<div className="unified-menu-dropdown" style={{
										display: 'block',
										position: 'static',
										background: '#ffffff',
										border: '1px solid #e5e7eb',
										borderRadius: '8px',
										boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
										padding: '8px 0',
										margin: '0',
										width: '100%',
										minWidth: '200px',
										transform: 'none'
									}}>
										{/* Account */}
										<div
											className="dropdown-item"
											onClick={() => {
												setIsThreeDotsMenuOpen(false);
												props.history.push(routes.PROFILE);
											}}
											style={{
												padding: '12px 16px',
												cursor: 'pointer',
												color: '#2c3e50',
												fontSize: '0.875rem',
												borderBottom: 'none',
												transition: 'background-color 0.2s ease',
												display: 'flex',
												alignItems: 'center'
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.backgroundColor = '#f9fafb';
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.backgroundColor = 'transparent';
											}}
										>
											<User className="me-2" size={18} color={"#2c3e50"} />
											<span>Account</span>
										</div>

										{/* Brands */}
										<div
											className="dropdown-item"
											onClick={() => {
												toggleThreeDotsBrandDropdown();
											}}
											style={{
												padding: '12px 16px',
												cursor: 'pointer',
												color: '#2c3e50',
												fontSize: '0.875rem',
												borderBottom: 'none',
												transition: 'background-color 0.2s ease',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between'
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.backgroundColor = '#f9fafb';
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.backgroundColor = 'transparent';
											}}
										>
											<div style={{ display: 'flex', alignItems: 'center' }}>
												{brand.id ? (
													<Package className="me-2" size={18} color={"#2c3e50"} />
												) : (
													<Globe className="me-2" size={18} color={"#2c3e50"} />
												)}
												<span>{brand.name || "All Brands"}</span>
											</div>
											{threeDotsBrandDropdown ? (
												<ChevronUp size={16} color={"#2c3e50"} />
											) : (
												<ChevronDown size={16} color={"#2c3e50"} />
											)}
										</div>

										{/* Notifications */}
										<div
											className="dropdown-item"
											onClick={() => {
												toggleThreeDotsNotificationDropdown();
											}}
											style={{
												padding: '12px 16px',
												cursor: 'pointer',
												color: '#2c3e50',
												fontSize: '0.875rem',
												borderBottom: 'none',
												transition: 'background-color 0.2s ease',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between'
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.backgroundColor = '#f9fafb';
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.backgroundColor = 'transparent';
											}}
										>
											<div style={{ display: 'flex', alignItems: 'center' }}>
												<Bell className="me-2" size={18} color={"#2c3e50"} />
												<span>Notifications</span>
											</div>
											{notificationCount > 0 && (
												<span
													style={{
														backgroundColor: '#ef4444',
														color: 'white',
														borderRadius: '50%',
														width: '20px',
														height: '20px',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														fontSize: '0.65rem',
														fontWeight: 700
													}}
												>
													{loadingNotifications ? (
														<Loader className="fa-spin" size={8} />
													) : (
														notificationCount > 10 ? "10+" : notificationCount
													)}
												</span>
											)}
										</div>

										<hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} />

										{/* View Mode - Hidden as per request */}
										{/* <div
	className="dropdown-item view-mode-toggle-item"
	style={{
		padding: '12px 16px',
		color: '#2c3e50',
		fontSize: '0.875rem',
		borderBottom: 'none'
	}}
>
	<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
		<span
			style={{ fontSize: '0.75rem', fontWeight: 500, color: '#2c3e50', marginBottom: '8px' }}
		>
			View Mode
		</span>
		<ViewModeToggle
			currentMode={props.currentViewMode}
			onModeChange={handleViewModeChange}
			className="dropdown-toggle"
		/>
	</div>
</div>

<hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} /> */}

										{/* Logout */}
										<div
											className="dropdown-item"
											onClick={() => {
												setIsThreeDotsMenuOpen(false);
												setShowLogoutModal(true);
											}}
											style={{
												padding: '12px 16px',
												cursor: 'pointer',
												color: '#2c3e50',
												fontSize: '0.875rem',
												borderBottom: 'none',
												transition: 'background-color 0.2s ease',
												display: 'flex',
												alignItems: 'center'
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.backgroundColor = '#f9fafb';
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.backgroundColor = 'transparent';
											}}
										>
											<LogOut className="me-2" size={18} color={"#2c3e50"} />
											<span>Logout</span>
										</div>
									</div>

									{/* Brands Dropdown - Show when brands item is clicked */}
									{threeDotsBrandDropdown && (
										<div className="brand-dropdown-wrapper" style={{ marginTop: "8px" }}>
											<div className="header-notification-container">
												<BrandDropdown handleSelect={handleBrandChange} enablePagination={true} />
											</div>
										</div>
									)}

									{/* Notifications Dropdown - Show when notifications item is clicked */}
									{threeDotsNotificationDropdown && (
										<div className="notification-dropdown-wrapper">
											<NotificationDropdown
												notifications={props.notifications}
												user={props.profile}
												markAsRead={props.markAsRead}
												setNotificationDropdown={setThreeDotsNotificationDropdown}
												notificationDropdown={threeDotsNotificationDropdown}
												notificationCount={notificationCount}
												getAllNotifications={props.getAllNotifications}
											/>
										</div>
									)}
								</div>
							)}
						</div>
					</div>

					{/* iPad Right Section - Contains three dots for iPad (768px - 1024px) */}
					<div className="d-none d-md-block d-lg-none ipad-right-section position-relative">
						<div className="ipad-three-dots-menu-wrapper position-relative">
							<button
								onClick={(e) => {
									toggleThreeDotsMenu();
								}}
								className="ipad-three-dots-menu-toggle"
								style={{
									border: "1px solid #e0e0e0",
									background: "#ffffff",
									padding: "8px",
									color: "#2c3e50",
									cursor: "pointer",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									borderRadius: "8px",
									position: "relative",
									zIndex: 1001,
									width: "40px",
									height: "40px",
									transition: "all 0.2s ease",
									boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)"
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = "#f9fafb";
									e.currentTarget.style.borderColor = "#d1d5db";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = "#ffffff";
									e.currentTarget.style.borderColor = "#e0e0e0";
								}}
							>
								<MoreVertical size={20} />
							</button>

							{/* iPad Three Dots Menu Dropdown */}
							{isThreeDotsMenuOpen && (
								<div
									className="ipad-three-dots-menu-container"
									style={{
										top: `${threeDotsMenuPosition.top}px`,
										left: `${threeDotsMenuPosition.left}px`
									}}
									onClick={(e) => e.stopPropagation()}
								>
									{/* Unified Menu - All items in one dropdown */}
									<DropdownMenu right className="unified-menu-dropdown">
										{/* Account */}
										<DropdownItem
											onClick={() => {
												setIsThreeDotsMenuOpen(false);
											}}
										>
											<Link to={routes.PROFILE}>
												<div className={"d-flex align-items-center"}>
													<User className="me-2" size={18} color={"#2c3e50"} />
													<span style={{ color: "#2c3e50", fontSize: "0.875rem" }}>Account</span>
												</div>
											</Link>
										</DropdownItem>

										{/* Brands Dropdown */}
										<DropdownItem
											onClick={() => {
												toggleThreeDotsBrandDropdown();
											}}
										>
											<div className={"d-flex align-items-center justify-content-between"}>
												<div className="d-flex align-items-center">
													{brand.id ? (
														<Package className="me-2" size={18} color={"#2c3e50"} />
													) : (
														<Globe className="me-2" size={18} color={"#2c3e50"} />
													)}
													<span style={{ color: "#2c3e50", fontSize: "0.875rem" }}>
														{brand.name || "All Brands"}
													</span>
												</div>
												{threeDotsBrandDropdown ? (
													<ChevronUp size={16} color={"#2c3e50"} />
												) : (
													<ChevronDown size={16} color={"#2c3e50"} />
												)}
											</div>
										</DropdownItem>

										{/* Notifications */}
										<DropdownItem
											onClick={() => {
												toggleThreeDotsNotificationDropdown();
											}}
										>
											<div className={"d-flex align-items-center justify-content-between"}>
												<div className="d-flex align-items-center">
													<Bell className="me-2" size={18} color={"#2c3e50"} />
													<span style={{ color: "#2c3e50", fontSize: "0.875rem" }}>Notifications</span>
												</div>
												{notificationCount > 0 && (
													<span
														className="notification-badge mobile-notification-badge"
														data-count={notificationCount > 10 ? "10+" : notificationCount.toString()}
													>
														{loadingNotifications ? (
															<Loader className="fa-spin" size={8} />
														) : (
															notificationCount > 10 ? "10+" : notificationCount
														)}
													</span>
												)}
											</div>
										</DropdownItem>

										<DropdownItem divider />

										{/* View Mode - Hidden as per request */}
										{/* <DropdownItem className="view-mode-toggle-item">
	<div className="d-flex flex-column" style={{ width: "100%" }}>
		<span
			className="mb-2"
			style={{ fontSize: "0.75rem", fontWeight: 500, color: "#2c3e50" }}
		>
			View Mode
		</span>
		<ViewModeToggle
			currentMode={props.currentViewMode}
			onModeChange={handleViewModeChange}
			className="dropdown-toggle"
		/>
	</div>
</DropdownItem>

<DropdownItem divider /> */}

										{/* Logout */}
										<DropdownItem
											onClick={() => {
												setIsThreeDotsMenuOpen(false);
												setShowLogoutModal(true);
											}}
										>
											<div className={"d-flex align-items-center"}>
												<LogOut className="me-2" size={18} color={"#2c3e50"} />
												<span style={{ color: "#2c3e50", fontSize: "0.875rem" }}>Logout</span>
											</div>
										</DropdownItem>
									</DropdownMenu>

									{/* Brands Dropdown - Show when brands item is clicked */}
									{threeDotsBrandDropdown && (
										<div className="brand-dropdown-wrapper" style={{ marginTop: "8px" }}>
											<div className="header-notification-container">
												<BrandDropdown handleSelect={handleBrandChange} enablePagination={true} />
											</div>
										</div>
									)}

									{/* Notifications Dropdown - Show when notifications item is clicked */}
									{threeDotsNotificationDropdown && (
										<div className="notification-dropdown-wrapper">
											<NotificationDropdown
												notifications={props.notifications}
												user={props.profile}
												markAsRead={props.markAsRead}
												setNotificationDropdown={setThreeDotsNotificationDropdown}
												notificationDropdown={threeDotsNotificationDropdown}
												notificationCount={notificationCount}
												getAllNotifications={props.getAllNotifications}
											/>
										</div>
									)}
								</div>
							)}
						</div>
					</div>

					{/* Desktop Nav - Show on large screens only (1025px+) */}
					<Collapse
						className="navbarbg h-100 d-none d-lg-flex custom-navbar-collapse"
						navbar
						data-navbarbg="skin1"
						isOpen={true}
					>
						<Nav navbar className="h-100 right-section-nav ms-auto">
							{/* Brands Dropdown */}
							<Dropdown nav inNavbar toggle={toggleBrandDropdown} isOpen={brandDropdown}>
								<DropdownToggle nav caret>
									<div className="brand-dropdown-container d-flex align-items-center">
										{brand.id ? (
											<Package className={"brand-icon"} height={18} width={18} color={"#2c3e50"} />
										) : (
											<Package className={"brand-icon"} height={18} width={18} color={"#2c3e50"} />
										)}
										<span className="brand-dropdown-text">{brand.name || "All brands"}</span>
										{brandDropdown ? (
											<ChevronUp className="brand-chevron" color={"#2c3e50"} size={16} />
										) : (
											<ChevronDown className="brand-chevron" color={"#2c3e50"} size={16} />
										)}
									</div>
								</DropdownToggle>
								<BrandDropdown handleSelect={handleBrandChange} enablePagination={true} />
							</Dropdown>

							{/* Notifications Dropdown */}
							<Dropdown
								nav
								inNavbar
								toggle={toggleNotificationDropdown}
								isOpen={notificationDropdown}
							>
								<DropdownToggle nav caret className="d-flex align-items-center">
									<div className="notification-container">
										<Bell size={20} color={"#2c3e50"} />
										{notificationCount > 0 && (
											<span
												className="notification-badge"
												data-count={notificationCount > 10 ? "10+" : notificationCount.toString()}
											>
												{loadingNotifications ? (
													<Loader className="fa-spin" size={8} />
												) : (
													notificationCount > 10 ? "10+" : notificationCount
												)}
											</span>
										)}
									</div>
								</DropdownToggle>
								<NotificationDropdown
									notifications={props.notifications}
									user={props.profile}
									markAsRead={props.markAsRead}
									setNotificationDropdown={setMobileNotificationDropdown}
									notificationDropdown={mobileNotificationDropdown}
									notificationCount={notificationCount}
									getAllNotifications={props.getAllNotifications}
								/>
							</Dropdown>

							{/* Profile Dropdown */}
							<UncontrolledDropdown nav inNavbar className={"account-dropdown"}>
								<DropdownToggle nav caret>
									<div className="profile-container d-flex align-items-center">
										<div
											id={"account-joyride"}
											className="profile-avatar rounded-circle d-flex justify-content-center align-items-center"
										>
											{props.profile?.user_photo ? (
												<ReactImageFallback
													src={props.profile.user_photo}
													fallbackImage={<User color={"#fff"} size={20} />}
													style={{
														height: 32,
														width: 32,
														borderRadius: 16
													}}
												/>
											) : (
												<User color={"#fff"} size={20} />
											)}
										</div>
										<div className="profile-info d-flex flex-column">
											<span className="profile-name">
												{props.profile?.first_name && props.profile?.last_name
													? `${props.profile.first_name} ${props.profile.last_name}`
													: props.profile?.email?.split("@")[0] || "User"}
											</span>
											<span className="profile-view">
												{props.currentViewMode === "supplier" ? "Supplier" : "Manufacturer"} view
											</span>
										</div>
										<ChevronDown className="profile-chevron" color={"#2c3e50"} size={16} />
									</div>
								</DropdownToggle>

								<DropdownMenu right>
									<DropdownItem>
										<Link to={routes.PROFILE}>
											<div className={"mt-2 d-flex"}>
												<User className="me-1 ms-1 color-bg-slate" size={18} />
												<span className="color-bg-slate">Account</span>
											</div>
										</Link>
									</DropdownItem>
									<DropdownItem divider />
									{/* View Mode - Hidden as per request */}
									{/* <DropdownItem className="view-mode-toggle-item">
	<div className="d-flex flex-column" style={{ width: "100%" }}>
		<span
			className="color-bg-slate mb-2"
			style={{ fontSize: "0.75rem", fontWeight: 500 }}
		>
			View Mode
		</span>
		<ViewModeToggle
			currentMode={props.currentViewMode}
			onModeChange={handleViewModeChange}
			className="dropdown-toggle"
		/>
	</div>
</DropdownItem>
<DropdownItem divider /> */}
									<DropdownItem
										onClick={() => {
											setShowLogoutModal(true);
										}}
									>
										<div className={"mt-2"}>
											<LogOut className="me-1 ms-1 color-bg-slate" size={18} />{" "}
											<span className="color-bg-slate">Logout</span>
										</div>
									</DropdownItem>
								</DropdownMenu>
							</UncontrolledDropdown>
						</Nav>
					</Collapse>

					{/* Mobile Nav - Only on small screens (below 768px) */}
					{isMobileMenuOpen && (
						<div
							className="d-md-none mobile-menu-container"
							style={{
								position: "absolute",
								top: "100%",
								left: 0,
								right: 0,
								zIndex: 1000,
								background: "#2c3e50",
								borderTop: "1px solid rgba(255, 255, 255, 0.1)",
								boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
								display: "block",
								visibility: "visible",
								opacity: 1,
								width: "100%",
								height: "auto"
							}}
						>
							<Nav
								navbar
								className="mobile-nav"
								style={{
									display: "flex",
									flexDirection: "column",
									width: "100%",
									background: "#2c3e50",
									padding: "1rem",
									marginTop: "0.5rem",
									position: "static",
									top: "auto",
									left: "auto",
									zIndex: "auto",
									visibility: "visible",
									opacity: 1,
									height: "auto"
								}}
							>
								{/* Brands Dropdown */}
								<Dropdown
									nav
									inNavbar
									toggle={toggleMobileBrandDropdown}
									isOpen={mobileBrandDropdown}
								>
									<DropdownToggle
										nav
										caret
										className="mobile-nav-item"
										style={{
											display: "flex",
											alignItems: "center",
											width: "100%",
											padding: "12px 16px",
											color: "white",
											textDecoration: "none",
											borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
											background: "transparent",
											border: "none",
											cursor: "pointer"
										}}
									>
										<div
											className="brand-dropdown d-flex align-items-center"
											style={{ width: "100%", justifyContent: "space-between" }}
										>
											<div style={{ display: "flex", alignItems: "center" }}>
												{brand.id ? (
													<Package
														className={"brand-icon"}
														height={20}
														color={"#fff"}
														style={{
															backgroundColor: "#3f65f1",
															padding: 4,
															borderRadius: "50%",
															marginRight: "8px"
														}}
													/>
												) : (
													<Globe
														className="color-bg-green"
														size={20}
														style={{ marginRight: "8px" }}
													/>
												)}
												<span style={{ color: "white", fontSize: "14px", fontWeight: 500 }}>
													{brand.name || "All Brands"}
												</span>
											</div>
											{mobileBrandDropdown ? (
												<ChevronUp style={{ color: "white" }} size={16} />
											) : (
												<ChevronDown style={{ color: "white" }} size={16} />
											)}
										</div>
									</DropdownToggle>
									<BrandDropdown handleSelect={handleBrandChange} enablePagination={true} />
								</Dropdown>

								{/* Notifications Dropdown */}
								<Dropdown
									nav
									inNavbar
									toggle={toggleMobileNotificationDropdown}
									isOpen={mobileNotificationDropdown}
								>
									<DropdownToggle
										nav
										caret
										className="mobile-nav-item d-flex align-items-center"
										style={{
											display: "flex",
											alignItems: "center",
											width: "100%",
											padding: "12px 16px",
											color: "white",
											textDecoration: "none",
											borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
											background: "transparent",
											border: "none",
											cursor: "pointer"
										}}
									>
										<div
											className="d-flex align-items-center"
											style={{ width: "100%", justifyContent: "space-between" }}
										>
											<div style={{ display: "flex", alignItems: "center" }}>
												<div
													className="notification-icon rounded-circle d-flex justify-content-center align-items-center"
													style={{
														width: 36,
														height: 36,
														fontSize: "1.2em",
														background:
															"linear-gradient(48.16deg, rgba(255, 89, 89, 0.75) -1.51%, rgba(255, 150, 28, 0.75) 50.45%, rgba(255, 188, 16, 0.75) 109.38%)",
														marginRight: "12px"
													}}
												>
													<Bell fill={"#FFF"} className="color-bg-White" size={18} />
												</div>
												<span style={{ color: "white", fontSize: "14px", fontWeight: 500 }}>
													Notifications
												</span>
											</div>
											{notificationCount > 0 && (
												<span
													className="notification-badge mobile-notification-badge"
													data-count={notificationCount > 10 ? "10+" : notificationCount.toString()}
												>
													{loadingNotifications ? (
														<Loader className="fa-spin" size={8} />
													) : (
														notificationCount > 10 ? "10+" : notificationCount
													)}
												</span>
											)}
										</div>
									</DropdownToggle>
									<NotificationDropdown
										notifications={props.notifications}
										user={props.profile}
										markAsRead={props.markAsRead}
										setNotificationDropdown={setMobileNotificationDropdown}
										notificationDropdown={mobileNotificationDropdown}
										notificationCount={notificationCount}
										getAllNotifications={props.getAllNotifications}
									/>
								</Dropdown>

								{/* Profile Dropdown */}
								<UncontrolledDropdown nav inNavbar className={"account-dropdown"}>
									<DropdownToggle
										nav
										caret
										className="mobile-nav-item"
										style={{
											display: "flex",
											alignItems: "center",
											width: "100%",
											padding: "12px 16px",
											color: "white",
											textDecoration: "none",
											borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
											background: "transparent",
											border: "none",
											cursor: "pointer"
										}}
									>
										<div
											className="d-flex align-items-center"
											style={{ width: "100%", justifyContent: "space-between" }}
										>
											<div style={{ display: "flex", alignItems: "center" }}>
												<div
													id={"account-joyride"}
													className="rounded-circle d-flex justify-content-center align-items-center"
													style={{
														background:
															"linear-gradient(42.3deg, rgba(57, 94, 250, 0.75) -0.63%, rgba(23, 201, 220, 0.75) 55.93%, rgba(29, 214, 174, 0.75) 117.41%)",
														width: 36,
														height: 36,
														boxShadow: "0px 0px 20px rgba(4, 25, 40, 0.05)",
														marginRight: "12px"
													}}
												>
													{props.profile?.user_photo ? (
														<ReactImageFallback
															src={props.profile.user_photo}
															fallbackImage={<User color={"#fff"} size={18} />}
															style={{
																height: 40,
																width: 40,
																borderRadius: 40
															}}
														/>
													) : (
														<User color={"#fff"} size={18} />
													)}
												</div>
												<span style={{ color: "white", fontSize: "14px", fontWeight: 500 }}>
													Profile
												</span>
											</div>
											<ChevronDown style={{ color: "white" }} size={16} />
										</div>
									</DropdownToggle>

									<DropdownMenu right>
										<DropdownItem>
											<Link to={routes.PROFILE}>
												<div className={"mt-2 d-flex"}>
													<User className="me-1 ms-1 color-bg-slate" size={18} />
													<span className="color-bg-slate">Account</span>
												</div>
											</Link>
										</DropdownItem>
										<DropdownItem divider />
										{/* View Mode - Hidden as per request */}
										{/* <DropdownItem className="view-mode-toggle-item">
	<div className="d-flex flex-column" style={{ width: "100%" }}>
		<span
			className="color-bg-slate mb-2"
			style={{ fontSize: "0.75rem", fontWeight: 500 }}
		>
			View Mode
		</span>
		<ViewModeToggle
			currentMode={props.currentViewMode}
			onModeChange={handleViewModeChange}
			className="dropdown-toggle"
		/>
	</div>
</DropdownItem>
<DropdownItem divider /> */}
										<DropdownItem
											onClick={() => {
												setShowLogoutModal(true);
											}}
										>
											<div className={"mt-2"}>
												<LogOut className="me-1 ms-1 color-bg-slate" size={18} />{" "}
												<span className="color-bg-slate">Logout</span>
											</div>
										</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</Nav>
						</div>
					)}
				</Navbar>
			</header>

			{/* Logout Confirmation Modal */}
			<LogoutConfirmationModal
				isOpen={showLogoutModal}
				toggle={() => setShowLogoutModal(false)}
				onConfirm={() => {
					props.logout();
				}}
			/>
		</>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	profile: state.user.profile || {},
	notifications: state.notification.all || [],
	selected_brand: state.user.selected_brand,
	currentViewMode: state.user.currentViewMode
});
const mapDispatchToProps = {
	logout: () => userService.logout(),
	fetchProfile: () => userService.getUserProfile(),
	markAsRead: (id: string) => notificationService.setNotificationAsRead(id),
	getAllNotifications: () => notificationService.getAllNotifications(),
	setSelectedBrand: (brand: IBrand) => userService.setSelectedBrand(brand),
	setViewMode: (mode: ViewMode) => (dispatch: Dispatch) => {
		dispatch(setViewModeAction(mode));
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
